import { IIntTermFieldSchema } from '../../repositories/newbuilding-promos/entities/json_query/IntTermFieldSchema';
import { EJsonQueryType, IJsonQueryTerm } from '../../types/jsonQuery/term';

export function mapJsonQueryNumberTerm(term?: IIntTermFieldSchema | null): IJsonQueryTerm<number> | null {
  if (!term) {
    return null;
  }

  return {
    type: EJsonQueryType.Term,
    value: term.value,
  };
}
